import { Reveal } from "@/components/Reveal";

const STATS = [
    { value: "3,200+", label: "Vetted influencer partners", sub: "Tier A to Tier C coverage" },
    { value: "1B+", label: "Campaign views generated", sub: "Across Meta, YouTube & Shorts" },
    { value: "2018", label: "Running campaigns since", sub: "Seven years of high-impact work" },
    { value: "A·B·C", label: "Full creator tier spectrum", sub: "Mega reach to micro trust" },
];

export default function Stats() {
    return (
        <section
            data-testid="stats-band"
            className="relative border-y border-white/10 bg-navy"
        >
            <div className="mx-auto grid max-w-7xl grid-cols-2 lg:grid-cols-4">
                {STATS.map((s, i) => (
                    <Reveal
                        key={s.value}
                        delay={i * 0.08}
                        className={`px-6 py-8 sm:px-10 sm:py-10 ${
                            i % 2 === 1 ? "border-l border-white/10" : ""
                        } ${i >= 2 ? "border-t border-white/10 lg:border-t-0" : ""} ${
                            i === 2 ? "lg:border-l lg:border-white/10" : ""
                        }`}
                    >
                        <p className="font-syne text-4xl font-extrabold tracking-tight text-white sm:text-5xl">
                            {s.value}
                        </p>
                        <p className="mt-3 text-sm font-semibold text-slate-200">{s.label}</p>
                        <p className="mt-1 text-xs text-slate-500">{s.sub}</p>
                    </Reveal>
                ))}
            </div>
        </section>
    );
}
